/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Meta_Bracket_Top_NInputs */



/**
* | output |
* | --- |
* | "Top {size}" |
*
* @param {Meta_Bracket_Top_NInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_bracket_top_n = /** @type {((inputs: Meta_Bracket_Top_NInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Bracket_Top_NInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Top ${i?.size}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Top ${i?.size}`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`前 ${i?.size} 名`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`前 ${i?.size} 名`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`상위 ${i?.size}`)
	return /** @type {LocalizedString} */ (`Top ${i?.size}`)
});